export default __webpack_public_path__ + "img/harald.9889e57e.jpg";